import { Action, ActionType } from "../action-types";

const initialState = false

const tfaReducer = (state = initialState, action:Action) => {
    switch (action.type) {
        case ActionType.SET_VERIFY_TFA:
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default tfaReducer;